var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92361 7L13.5633 0.277539C13.6578 0.16582 13.5783 -0.00390625 13.4322 -0.00390625H11.7178C11.6168 -0.00390625 11.5201 0.0412109 11.4535 0.118555L6.80213 5.66367L2.15076 0.118555C2.08631 0.0412109 1.98963 -0.00390625 1.8865 -0.00390625H0.172047C0.0259535 -0.00390625 -0.0535388 0.16582 0.0409924 0.277539L5.68064 7L0.0409924 13.7225C0.0198165 13.7474 0.0062314 13.7778 0.00184938 13.8102C-0.00253265 13.8426 0.00247249 13.8756 0.0162711 13.9052C0.0300697 13.9348 0.0520821 13.9599 0.0796945 13.9774C0.107307 13.9949 0.13936 14.0041 0.172047 14.0039H1.8865C1.98748 14.0039 2.08416 13.9588 2.15076 13.8814L6.80213 8.33633L11.4535 13.8814C11.5179 13.9588 11.6146 14.0039 11.7178 14.0039H13.4322C13.5783 14.0039 13.6578 13.8342 13.5633 13.7225L7.92361 7Z",
    fill: "#798596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.2ea94eb6215ee03a795e32ff0b539875.svg";
export { ForwardRef as ReactComponent };